export function MvpVoterIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M24 8l2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z" />
      <rect x="12" y="28" width="24" height="12" rx="2" />
      <line x1="18" y1="28" x2="18" y2="40" />
      <path d="M22 34l2 2 4-4" />
    </svg>
  );
}
